<template>
  <div>
    <el-dialog
      :title="selfDetail.formData.id ? '编辑调拨单' : '新增调拨单'"
      width="1200px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-form ref="refForm" :config="formConfig" :column="formColumn" :data.sync="selfDetail.formData" />
        <div class="flex flex-y-center m-t-10">
          <div class="group-title">调拨明细</div>
          <el-link class="m-b-5 m-l-10" type="primary" size="mini" @click="chooseStock">
            <span>从调出仓库存选择</span>
            <span class="c-red">({{ selfDetail.list.length }})</span>
          </el-link>
          <el-link class="m-b-5 m-l-10" type="success" size="mini" @click="itemAdd"> 增行 </el-link>
          <span class="m-l-10 c-gray f-s-12">审核时执行调出仓扣减并写入调入仓，同仓库调拨请使用库内移仓</span>
        </div>
        <vxe-grid
          ref="refTable"
          :min-height="tableConfig.minHeight"
          :toolbar-config="tableConfig.toolbarConfig"
          :edit-config="tableConfig.editConfig"
          :row-config="tableConfig.rowConfig"
          :mouse-config="tableConfig.mouseConfig"
          :keyboard-config="tableConfig.keyboardConfig"
          :columns="tableColumn"
          :data="selfDetail.list"
          :show-footer="!!selfDetail.list.length"
          :max-height="this.$util.getViewHeight() - 460"
          :footer-method="tableFooterMethod"
        >
          <template #default_amount="{ row }">
            <span class="c-orange">{{ row.amount }}</span>
          </template>
          <template #default_operate="{ rowIndex }">
            <el-link title="清空" @click="itemClear(rowIndex)"> 清空 </el-link>
            <el-link title="删行" @click="itemDelete(rowIndex)"> 删行 </el-link>
          </template>

          <template #edit_material_name="{ row }">
            <el-input v-model="row.material_name" size="mini" clearable />
          </template>
          <template #edit_category="{ row }">
            <el-input v-model="row.category" size="mini" clearable />
          </template>
          <template #edit_spec="{ row }">
            <el-input v-model="row.spec" size="mini" clearable />
          </template>
          <template #edit_unit="{ row }">
            <el-input v-model="row.unit" size="mini" clearable />
          </template>
          <template #edit_batch_no="{ row }">
            <el-input v-model="row.batch_no" size="mini" clearable />
          </template>
          <template #edit_qty="{ row }">
            <el-input v-model="row.qty" type="number" size="mini" clearable @blur="countsBlur(row)" />
          </template>
          <template #edit_price="{ row }">
            <el-input v-model="row.price" type="number" size="mini" clearable @blur="countsBlur(row)" />
          </template>
          <template #edit_to_location_id="{ row }">
            <el-select v-model="row.to_location_id" size="mini" clearable @change="onRowToLocationChange(row)">
              <el-option v-for="opt in toLocationOptions" :key="opt.val" :label="opt.key" :value="opt.val" />
            </el-select>
          </template>
          <template #edit_remark="{ row }">
            <el-input v-model="row.remark" size="mini" clearable />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" :loading="saving" :disabled="saving" @click="popupPush">保存</el-button>
      </div>
    </el-dialog>
    <PopupChooseStock
      v-if="isShowPopupChooseStock"
      :show.sync="isShowPopupChooseStock"
      :cond="chooseStockCond"
      :list="selfDetail.list"
      @success="chooseStockSuccess"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupChooseStock: () => import('./popup-choose-stock')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      selfShow: false,
      saving: false,
      warehouseList: [],
      toLocationList: [],
      isShowPopupChooseStock: false,
      selfDetail: {
        formData: {
          id: '',
          bill_no: '',
          bill_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'),
          from_warehouse_id: '',
          from_warehouse_name: '',
          to_warehouse_id: '',
          to_warehouse_name: '',
          remark: ''
        },
        list: []
      },
      formConfig: {
        inline: true,
        width: '360px'
      },
      tableColumn: [
        { fixed: 'left', title: '序号', type: 'seq', width: 40 },
        { title: '物料名称', field: 'material_name', width: 140, slots: { edit: 'edit_material_name' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '材质', field: 'category', width: 90, slots: { edit: 'edit_category' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '规格(mm)', field: 'spec', width: 120, slots: { edit: 'edit_spec' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '单位', field: 'unit', width: 60, slots: { edit: 'edit_unit' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '批号', field: 'batch_no', width: 110, slots: { edit: 'edit_batch_no' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '调出仓位', field: 'from_location_name', width: 90 },
        { title: '调拨数量', field: 'qty', width: 90, slots: { edit: 'edit_qty' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '调入仓位', field: 'to_location_id', width: 110, slots: { edit: 'edit_to_location_id' } },
        { title: '单价(元)', field: 'price', width: 90, slots: { edit: 'edit_price' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '金额(元)', field: 'amount', width: 100, slots: { default: 'default_amount' } },
        { title: '备注', field: 'remark', width: 110, slots: { edit: 'edit_remark' }, editRender: { autofocus: '.el-input__inner' } },
        { title: '操作', fixed: 'right', slots: { default: 'default_operate' }, width: 90 }
      ]
    }
  },
  computed: {
    disabled() {
      // 已审核/已作废不可编辑（列表已控制入口，这里做兜底）
      let st = Number(this.selfDetail.formData.status)
      return st === 2 || st === 3
    },
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    warehouseOptions() {
      return this.warehouseList.map((item) => ({ key: item.warehouse_name, val: item.id }))
    },
    toLocationOptions() {
      return this.toLocationList.map((item) => ({ key: item.location_name || item.location_code, val: item.id }))
    },
    chooseStockCond() {
      return {
        warehouseId: this.selfDetail.formData.from_warehouse_id,
        warehouse_name: this.selfDetail.formData.from_warehouse_name
      }
    },
    formColumn() {
      return [
        { type: 'text', title: '调拨单号', field: 'bill_no', placeholder: '自动生成', disabled: true },
        { type: 'date', title: '调拨日期', field: 'bill_date', format: 'yyyy-MM-dd', valueFormat: 'yyyy-MM-dd' },
        {
          type: 'select',
          title: '调出仓库',
          field: 'from_warehouse_id',
          options: this.warehouseOptions,
          fnChange: () => this.onFromWarehouseChange()
        },
        {
          type: 'select',
          title: '调入仓库',
          field: 'to_warehouse_id',
          options: this.warehouseOptions,
          fnChange: () => this.onToWarehouseChange()
        },
        { type: 'text', title: '备注', field: 'remark' }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getWarehouseList()
    if (this.id) {
      this.getDetailData()
    }
  },
  methods: {
    getWarehouseList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/newWarehouse/list',
        data: { currentPage: 1, pageSize: this.$constant.pageMax, sortData: 'id desc' }
      })
        .then((res) => {
          if (res.status === 200) {
            this.warehouseList = (res.data.page && res.data.page.list) || []
          }
        })
        .catch(() => {})
    },
    getToLocationList(warehouseId) {
      if (!warehouseId) {
        this.toLocationList = []
        return
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/warehouseLocation/list',
        data: { currentPage: 1, pageSize: this.$constant.pageMax, warehouseId, deleted: false, sortData: 'id desc' }
      })
        .then((res) => {
          if (res.status === 200) {
            this.toLocationList = (res.data.page && res.data.page.list) || []
          }
        })
        .catch(() => {})
    },
    onFromWarehouseChange() {
      let wh = this.warehouseList.find((item) => item.id === this.selfDetail.formData.from_warehouse_id)
      this.selfDetail.formData.from_warehouse_name = wh ? wh.warehouse_name : ''
    },
    onToWarehouseChange() {
      let wh = this.warehouseList.find((item) => item.id === this.selfDetail.formData.to_warehouse_id)
      this.selfDetail.formData.to_warehouse_name = wh ? wh.warehouse_name : ''
      this.getToLocationList(this.selfDetail.formData.to_warehouse_id)
      // 调入仓变化后清空各行已选的调入仓位
      this.selfDetail.list.forEach((row) => {
        row.to_location_id = ''
        row.to_location_name = ''
      })
    },
    onRowToLocationChange(row) {
      let lo = this.toLocationList.find((item) => item.id === row.to_location_id)
      row.to_location_name = lo ? lo.location_name || lo.location_code : ''
    },
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/stockTransfer/detail',
        params: { id: this.id }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let fd = res.data.formData || {}
          let keys = ['bill_no', 'bill_date', 'from_warehouse_name', 'to_warehouse_name', 'remark']
          keys.forEach((k) => {
            if (fd[k] === null || fd[k] === undefined) fd[k] = ''
          })
          if (fd.bill_date) {
            fd.bill_date =
              typeof fd.bill_date === 'string'
                ? fd.bill_date.substring(0, 10)
                : this.$XEUtils.toDateString(fd.bill_date, 'yyyy-MM-dd')
          }
          this.selfDetail.formData = fd
          this.getToLocationList(fd.to_warehouse_id)
          this.selfDetail.list = (res.data.list || []).map((item) => {
            item.qty = item.qty === null || item.qty === undefined ? '' : item.qty
            item.price = item.price === null || item.price === undefined ? '' : item.price
            item.amount = item.amount === null || item.amount === undefined ? '' : item.amount
            item.batch_no = item.batch_no || ''
            item.from_location_name = item.from_location_name || ''
            item.to_location_id = item.to_location_id || ''
            item.to_location_name = item.to_location_name || ''
            item.remark = item.remark || ''
            return item
          })
        }
      })
    },
    chooseStock() {
      if (!this.selfDetail.formData.from_warehouse_id) {
        this.$message.warning('请先选择调出仓库')
        return
      }
      this.isShowPopupChooseStock = true
    },
    chooseStockSuccess(rows) {
      let resultOld = this.$util.deepCopy(this.selfDetail.list)
      let resultStart = []
      let resultEnd = []
      resultOld.forEach((itemSt) => {
        let isKeep = rows.some((itemNd) => itemNd.source_item_id === itemSt.source_item_id)
        if (isKeep) resultStart.push(itemSt)
      })
      rows.forEach((itemNd) => {
        let isRepeat = resultOld.some((itemSt) => itemSt.source_item_id === itemNd.source_item_id)
        if (!isRepeat) {
          // 库存行 -> 调拨明细行
          resultEnd.push({
            material_name: itemNd.material_name || '',
            category: itemNd.category || '',
            spec: itemNd.spec || '',
            unit: itemNd.unit || '',
            batch_no: itemNd.batch_no || '',
            from_location_id: itemNd.location_id,
            from_location_name: itemNd.location_name || '',
            to_location_id: '',
            to_location_name: '',
            qty: '',
            weight: itemNd.weight || '',
            price: '',
            amount: '',
            source_item_id: itemNd.source_item_id,
            remark: ''
          })
        }
      })
      this.selfDetail.list = [...resultStart, ...resultEnd]
    },
    itemAdd() {
      this.selfDetail.list.push({
        material_name: '',
        category: '',
        spec: '',
        unit: '',
        batch_no: '',
        from_location_id: '',
        from_location_name: '',
        to_location_id: '',
        to_location_name: '',
        qty: '',
        weight: '',
        price: '',
        amount: '',
        source_item_id: '',
        remark: ''
      })
    },
    countsBlur(row) {
      row.amount = this.$XEUtils.multiply(Number(row.price) || 0, Number(row.qty) || 0)
    },
    itemClear(index) {
      let row = this.selfDetail.list[index]
      if (!row) return
      row.material_name = ''
      row.category = ''
      row.spec = ''
      row.unit = ''
      row.batch_no = ''
      row.from_location_id = ''
      row.from_location_name = ''
      row.to_location_id = ''
      row.to_location_name = ''
      row.qty = ''
      row.price = ''
      row.amount = ''
      row.remark = ''
    },
    itemDelete(index) {
      this.selfDetail.list.splice(index, 1)
    },
    tableFooterMethod({ columns, data }) {
      data.forEach((item) => {
        item.amount = this.$XEUtils.multiply(Number(item.price) || 0, Number(item.qty) || 0)
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['qty', 'amount'].includes(column.field)) {
            return this.$tool.listAddTotal(data, column.field)
          }
        })
      ]
    },
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    popupPush() {
      if (this.saving) return
      let fd = this.selfDetail.formData
      if (!fd.from_warehouse_id || !fd.to_warehouse_id) {
        this.$message.warning('请选择调出仓库和调入仓库')
        return
      }
      if (fd.from_warehouse_id === fd.to_warehouse_id) {
        this.$message.warning('调出与调入仓库不能相同（同仓库移位请使用库内移仓功能）')
        return
      }
      if (!this.selfDetail.list.length) {
        this.$message.warning('请至少录入一行调拨明细')
        return
      }
      let bad = this.selfDetail.list.some((item) => !item.material_name || !(Number(item.qty) > 0))
      if (bad) {
        this.$message.warning('存在物料名称为空或调拨数量不大于0的明细行')
        return
      }
      let data = this.$util.deepCopy(this.selfDetail)
      data.list.forEach((item) => {
        // 每行补齐调入仓位名称（el-select 变更时已设置，此处兜底）
        if (item.to_location_id && !item.to_location_name) {
          let lo = this.toLocationList.find((l) => l.id === item.to_location_id)
          item.to_location_name = lo ? lo.location_name || lo.location_code : ''
        }
      })
      this.saving = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/stockTransfer/saveOrUpdate',
        data
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.popupCancel()
            this.$emit('success')
            this.$message.success('保存成功')
          }
        })
        .catch(() => {})
        .then(() => {
          this.saving = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .group-title {
    font-size: 13px;
    font-weight: bold;
    color: @colorBlack;
  }
}
</style>
